<template>
  <div class="container">
    <!-- 背景层 -->
    <div class="footprint-bg" v-if="!isNanhaiView" :style="{
  backgroundImage: `url(${require('@/assets/headerbg.webp')})`,
  backgroundRepeat: 'repeat',
  backgroundSize: '400px auto',
  backgroundPosition: 'center'
}">
</div>

    <!-- 顶部操作栏 -->
    <div class="header">
      <button class="back-btn" @click="goHome">返回</button>
      <h2 class="city-title">{{$route.query.view === 'nanhai' ? "南海诸岛" : provinceName}}</h2>
    </div>
    
    <!-- 省份地图容器 -->
    <div :class="isNanhaiView ? 'map-fullscreen-wrap' : 'map-stage'">
      <div class="map-wrap" :class="{ 'map-wrap-nanhai': isNanhaiView }" ref="cityMapRef"></div>
    </div>

    <!-- 城市记录弹窗 -->
    <div v-if="showCityModal" class="modal-mask" @click.self="closeModal">
      <div class="modal-box">
        <h3>{{currentCityName}} · 足迹列表</h3>
        <div class="record-scroll-wrap">
        <div class="record-item" v-for="item in cityRecordList" :key="item.id" @click="openDetail(item)">
          <div>{{item.arriveTime || '未填写时间'}}</div>
          <div>{{item.note ? item.note.slice(0,20) : '无笔记'}}</div>
        </div>
       </div>
        <div class="btn-group-row">
        <button class="add-one" @click="addNewVisit">新增足迹记录</button>
        <button class="close" @click="closeModal">关闭</button>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// 引入统一数据接口，和首页FootprintMap同源
import { getFootprintList } from '@/api/footprint'

const provinceAdcodeMap = {
  "北京市":"110000",
  "天津市":"120000",
  "河北省":"130000",
  "山西省":"140000",
  "内蒙古自治区":"150000",
  "辽宁省":"210000",
  "吉林省":"220000",
  "黑龙江省":"230000",
  "上海市":"310000",
  "江苏省":"320000",
  "浙江省":"330000",
  "安徽省":"340000",
  "福建省":"350000",
  "江西省":"360000",
  "山东省":"370000",
  "河南省":"410000",
  "湖北省":"420000",
  "湖南省":"430000",
  "广东省":"440000",
  "广西壮族自治区":"450000",
  "海南省":"460000",
  "重庆市":"500000",
  "四川省":"510000",
  "贵州省":"520000",
  "云南省":"530000",
  "西藏自治区":"540000",
  "陕西省":"610000",
  "甘肃省":"620000",
  "青海省":"630000",
  "宁夏回族自治区":"640000",
  "新疆维吾尔自治区":"650000",
  "台湾省":"710000",
  "香港":"810000",
  "香港特别行政区":"810000",
  "澳门":"820000",
  "澳门特别行政区":"820000"
}
export default {
  name:"Province",
  data(){
    return{
      provinceName:"",
      myChart:null,
      clickLock: false,
      modalOpenTime: 0,
      footprintList: [],
      cityFootData: [],
      isLoadingMap: false,
      showCityModal: false,
      currentCityName: "",
      cityRecordList: [],
      isNanhaiView: false,
      provinceAdcode: ""
    }
  },
    async mounted() {
    // 从路由手动初始化省份名称
    const route = this.$route
    if (route.query.name) {
      this.provinceName = route.query.name
      this.isNanhaiView = route.query.view === 'nanhai'
    }
    await this.$nextTick(async () => {
      await this.initMap()
    })
    window.addEventListener('resize', this.handleResize)
  },
  watch:{
    $route:{
      handler(to){
        this.handleRouteChange(to)
      }
     }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    if(this.myChart){
      this.myChart.dispose()
      this.myChart = null
    }
    this.isLoadingMap = false
  },
methods:{
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    handleRouteChange(route){
      let newName = route.query.name
      if(newName === undefined) return
      if(newName === this.provinceName || this.isLoadingMap) return

      this.isNanhaiView = route.query.view === "nanhai"
      this.provinceName = newName
      this.isLoadingMap = true

      this.$nextTick(async ()=>{
        try{
          await this.initMap()
        }finally{
          this.isLoadingMap = false
        }
      })
    },
    goHome(){
      this.$router.push('/')
    },
    async loadGroupFootprint(){
      let viewGroupId = this.$route.query.viewGroupId
      // 兜底：URL 没带角色时，从 localStorage 读当前角色
      if (!viewGroupId) {
        const cached = JSON.parse(localStorage.getItem('currentUser') || '{}')
        viewGroupId = cached.currentGroupId || 'personal'
      }
      // ===== 新增：如果是汇总模式，传 undefined 让后端返回全量 =====
      if (viewGroupId === 'summary') {
        viewGroupId = undefined 
      }
      // =========================================================
      this.footprintList = await getFootprintList(viewGroupId)

      const provinceRecords = this.footprintList.filter(item=> item.province === this.provinceName)

      const cityNameArr = [...new Set(provinceRecords.map(item => item.city))]
      this.cityFootData = cityNameArr.map(name => {
        return {
          name: name,
          value: 1
        }
      })
    },
        async initMap(){
      const mapDom = this.$refs.cityMapRef
      if(!mapDom){
        console.error("地图DOM不存在，终止初始化")
        return
      }
      // 先解绑当前实例事件
      if(this.myChart){
        this.myChart.off('click')
        this.myChart.dispose()
        this.myChart = null
      }
      // 检查 DOM 上是否还残留 echarts 实例
      const existing = echarts.getInstanceByDom(mapDom)
      if(existing){
        existing.dispose()
      }
      // 清空旧画布
      mapDom.innerHTML = ''
      this.myChart = echarts.init(mapDom)
      console.log("当前省份名称：", this.provinceName)
      const mapFile = provinceAdcodeMap[this.provinceName]
      console.log("拿到的地图文件名：", mapFile)
      if(!mapFile){
        alert("找不到该省份地图文件：" + this.provinceName)
        return
      }
      this.provinceAdcode = mapFile
      try {
        const res = await fetch(`/map/${mapFile}.json`)
        if(!res.ok) throw new Error("地图文件加载失败")
        const provinceGeo = await res.json()
        echarts.registerMap(mapFile, provinceGeo)
        console.log(`✅ ${mapFile}地图注册完成`)
      }catch(err){
        console.error("地图GeoJson加载异常", err)
        alert("地图资源加载失败，请重试")
        return
      }

      // 地图注册完成后，再读取足迹
      await this.loadGroupFootprint() 

      let visitedCity = []
      if(this.isNanhaiView){
        const nanhaiCityList = ["西沙群岛","中沙群岛","南沙群岛"]
        visitedCity = [...new Set(
          this.footprintList.filter(item=>
            item.province === this.provinceName && nanhaiCityList.includes(item.city)
          ).map(i=>i.city)
        )].map(name=>({name, value:1}))
      }else{
        visitedCity = [...new Set(this.footprintList.filter(item=>item.province === this.provinceName).map(i=>i.city))]
        .map(name => ({ name, value: 1 }))
      }

      let mapCenter = undefined
      let mapZoom = undefined
      let areaColor = '#e6e6e6'
      if(this.isNanhaiView){
        mapCenter = [114.0, 8.4]
        mapZoom = 2.8
        areaColor = '#d7ecff'
      }
      else if(this.provinceName === "海南省"){
        mapCenter = [110.35, 19.25]
        mapZoom = 7.2
      }
      const highlightShadow = 'rgba(64,158,255,0.4)'
      const option = {
        tooltip:{trigger:'item'},
        visualMap: {
          show:false,
          min:0,
          max:1,
          inRange:{
            color:[areaColor,'#409eff']
          }
        },
        series:[
          {
            type:'map',
            map: mapFile,
            roam:true,
            ...(mapCenter ? {center: mapCenter, zoom: mapZoom} : {}),
            label:{
              show:true,
              fontSize:10
            },
            itemStyle: {
              areaColor: areaColor,
              borderColor: this.isNanhaiView ? '#93c5ee' : '#9ca3af',
              borderWidth: 1,
              shadowBlur: 8,
              shadowColor: 'rgba(0, 0, 0, 0.12)',
              shadowOffsetX: 0,
              shadowOffsetY: 2
            },
            emphasis: {
              itemStyle: {
                borderColor: 'rgba(255,255,255,0.95)',
                borderWidth: 2,
                shadowBlur: 18,
                shadowColor: highlightShadow,
                shadowOffsetX: 0,
                shadowOffsetY: 6
              },
              label: {
                fontWeight: 'bold',
                color: '#222'
              }
            },
            data: visitedCity
          }
        ]
      }
      if(this.myChart){
        this.myChart.setOption(option)
        if(this.isNanhaiView){
          this.myChart.resize()
        }
      }

           // 地图点击事件
      this.myChart.off('click')
      this.myChart.on('click',(params)=>{
        // 防抖：250ms 内只响应一次
        if (this.clickLock) return
        if (!params || !params.name) return
        if (this.showCityModal) return
        this.clickLock = true
        setTimeout(() => { this.clickLock = false }, 250)

        const cityName = params.name
        const allRecords = this.footprintList.filter(item => item.province === this.provinceName && item.city === cityName)
        this.currentCityName = cityName
        this.cityRecordList = allRecords

         // 立即弹窗，同时记录时间戳，200ms 内的按钮点击会被忽略
        this.modalOpenTime = Date.now()
        this.showCityModal = true
      })
    },
      openDetail(record){
      if (Date.now() - this.modalOpenTime < 250) return
      this.showCityModal = false
      this.$router.push({
        path:'/detail',
        query:{
          province: this.provinceName,
          city: this.currentCityName,
          id: record.id
        }
      })
    },
       addNewVisit(){
      if (Date.now() - this.modalOpenTime < 250) return
      this.showCityModal = false
      this.$router.push({
        path:'/addRecord',
        query:{
          province: this.provinceName,
          city: this.currentCityName
        }
      })
    },
         closeModal(){
      // 250ms 内不允许关闭，避免刚打开就被同一次点击关闭
      if (Date.now() - this.modalOpenTime < 250) return
      this.showCityModal = false
    }
}
}
</script>

<style scoped>
/* ============================================================
   1. 页面骨架与背景
   ============================================================ */
.container {
  padding: 0; /* 清理之前的 padding，防止地图偏移 */
  min-height: 100vh;
  position: relative;
}

.footprint-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

/* ============================================================
   2. Header：全透明悬浮，左对齐排版
   ============================================================ */
.header {
  position: absolute; 
  top: 0;
  left: 0;
  width: 100%;
  z-index: 15;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 👈 靠左对齐 */
  height: clamp(48px, 7vh, 68px); 
  padding: 0 clamp(16px, 3vw, 24px); 
  box-sizing: border-box;
  gap: clamp(12px, 2vw, 20px); /* 👈 按钮和文字的间距 */
  
  /* 👇 彻底去掉玻璃背景，只保留透明 */
  background: transparent;
  border-bottom: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: none;
}

/* 返回键：高度与文字绝对齐平 */
.back-btn {
  border-radius: 6px; 
  padding: 0 clamp(8px, 1.2vw, 14px); 
  
  /* 👇 核心：高度和标题文字大小绑定，确保齐平 */
  height: clamp(24px, 3.2vh, 28px); 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  /* 保持纯白微光质感 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}

/* 标题：靠左排列，去掉绝对定位 */
.city-title,
div.header h2 {
  position: relative !important; 
  left: auto !important;
  transform: none !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  font-size: clamp(16px, 2.1vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 2px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1 !important; /* 行高设为1，配合高度对齐 */
  
  /* 防止长名字把返回键挤走 */
  max-width: 70% !important; 
  overflow: hidden;
  text-overflow: ellipsis;
  
  /* 保留纯白浮雕发光，让它在透明背景下依然清晰 */
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}
/* ============================================================
   3. 全屏地图容器（保持你的原样，不改动核心）
   ============================================================ */
.map-stage {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
}
.map-stage .map-wrap {
  width: 100%;
  max-width: unset;
  height: 100%;
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
  border: none;
  outline: none;
  overflow: hidden;
}
.map-fullscreen-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}
.map-fullscreen-wrap .map-wrap {
  width: 100%;
  height: 100%;
  max-width: unset;
  border-radius: 0;
}
.map-wrap-nanhai {
  background-color: #ced4da !important;
}

/* ============================================================
   4. 足迹列表弹窗（高光磨砂玻璃）
   ============================================================ */
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 16px;
  box-sizing: border-box;
}

.modal-box {
  width: clamp(280px, 85vw, 400px);
  max-height: 80vh; 
  border-radius: 16px;
  padding: clamp(14px, 2.5vh, 20px) clamp(16px, 2.5vw, 24px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column; 
  
  /* 👇 高光磨砂玻璃 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), inset 0 1px 2px rgba(255, 255, 255, 1);
}

.modal-box h3 {
  margin: 0 0 clamp(8px, 1.5vh, 12px) 0;
  text-align: center;
  font-size: clamp(15px, 1.8vw, 18px) !important;
  color: #d14a4a;
  font-weight: 800;
  letter-spacing: 1px;
  flex-shrink: 0;
}

/* 中间列表滚动区域 */
.record-scroll-wrap {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin: clamp(4px, 1vh, 8px) 0;
  
  /* 隐藏滚动条，更优雅 */
  scrollbar-width: none;
}
.record-scroll-wrap::-webkit-scrollbar {
  display: none;
}

.record-item {
  padding: clamp(6px, 1.2vh, 10px) clamp(8px, 1.2vw, 12px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  cursor: pointer;
  font-size: clamp(12px, 1.2vw, 14px);
  line-height: 1.5;
  border-radius: 8px;
  transition: all 0.2s;
  margin-bottom: 4px;
}
.record-item:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: translateX(2px);
}
.record-item > div:first-child {
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 2px;
}
.record-item > div:last-child {
  color: #777;
  font-size: clamp(11px, 1.1vw, 13px);
}

/* ============================================================
   5. 弹窗底部按钮组（高光琉璃）
   ============================================================ */
.btn-group-row {
  display: flex;
  justify-content: center; 
  gap: clamp(10px, 2vw, 16px);
  margin-top: clamp(8px, 1.5vh, 12px);
  flex-shrink: 0;
}

.add-one,
.close {
  /* 👇 自适应宽高，取消死板的 110px */
  flex: 1;
  max-width: 140px;
  height: auto;
  padding: clamp(4px, 0.8vh, 6px) 0;
  border-radius: 6px; 
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

/* 新增足迹：绿色琉璃 */
.add-one {
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.85);
  box-shadow: 0 3px 8px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.add-one:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.95);
  transform: translateY(-1px);
}

/* 关闭：灰色琉璃 */
.close {
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,0.1)), rgba(144, 147, 153, 0.85);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.6);
}
.close:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.6), rgba(255,255,255,0.2)), rgba(144, 147, 153, 0.95);
  transform: translateY(-1px);
}

.add-one:active,
.close:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>